import { Badge } from 'antd';
import styled from 'styled-components';

export const StyledBadge = styled(Badge)`
  margin-right: 12px;
`;
